module.exports = __webpack_public_path__ + "img/type-video-interview.3c89167d.svg";